import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { Http } from '@angular/http';
import { RequestBuilder } from '../classes/request-builder';
import { Observable } from 'rxjs';
import * as Enum from '../utils/enums'
import * as Constants from '../utils/constants'

@Injectable({
  providedIn: 'root'
})
export class LoginService extends BaseService {
  /**
   * Costruttore
   * @param http Servizio di richieste HTTP 
   */
  constructor(http: Http) {
    super(http);
  }

  /**
   * login service
   * @param reqBuilder data
   */
  login(reqBuilder?: RequestBuilder): Observable<any> {
    let payload
    if (reqBuilder) {
      payload = reqBuilder
    }
    return this.doPost(Constants.URL_LOGIN, payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  /**
   * change password service
   * @param reqBuilder 
   */
  changePassword(reqBuilder?: RequestBuilder): Observable<any> {
    let payload
    if (reqBuilder) {
      payload = reqBuilder
    }
    return this.doPost("auth/ChangePassword", payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  /**
   * check gdpr for user
   * @param reqBuilder 
   */
  checkGDPR(reqBuilder?: RequestBuilder): Observable<any> {
    let payload
    if (reqBuilder) {
      payload = reqBuilder
    }
    return this.doPost("auth/CheckGDPR", payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  /**
   * update GDPR for user
   * @param reqBuilder 
   */
  updateGDPR(reqBuilder?: RequestBuilder): Observable<any> {
    let payload
    if (reqBuilder) {
      payload = reqBuilder
    }
    return this.doPost("auth/SetFlagGDPR", payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }
}